import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common'; // Import CommonModule

import { ReactiveFormsModule } from '@angular/forms';

import { BlockTextComponent } from '../../../common/block-text/block-text.component';

import {
  PropertyDescriptionInitModel,
  PropertyDescriptionInitVariables,
  PropertyDescriptionModel,
  PropertyDescriptionVariables,
} from '../../../../../models/email-template/property-description.interface';
import { BaseComponent } from '../../../common/BaseComponent';
import { NotificationComponent } from '../../../common/notification/notification.component';
import { PinComponent } from '../../../common/pin/pin.component';
import { Helper } from '../../../../../utils/helper';

@Component({
    selector: 'app-property-description',
    imports: [
        CommonModule,
        NotificationComponent,
        ReactiveFormsModule,
        BlockTextComponent,
        PinComponent,
    ],
    templateUrl: './property-description.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './property-description.component.scss'
})
export class PropertyDescriptionComponent extends BaseComponent implements OnInit {
  @Input() block: PropertyDescriptionModel = new PropertyDescriptionInitModel();
  @Input() isPreview = false;
  @Output() blockData = new EventEmitter<any>();
  @Output() removeBlockEvent = new EventEmitter<string | null>();

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new PropertyDescriptionInitVariables()
    }
  }

  //placeholders:
  imageDesktopPlaceholder: string = 'Desktop Image';
  imageMobilePlaceholder: string = 'Mobile Image';
  imageHrefPlaceholder: string = 'Enter Image Redirect Link';
  imageAltPlaceholder: string = 'Enter Image Alt Text';
  namePlaceholder: string = 'Enter Property Name';
  descriptionPlaceholder: string = 'Enter Description';
  ctaLinkPlaceholder: string = 'Enter CTA Link';
  ctaTextPlaceholder: string = 'Enter CTA Text';

  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId); // Emit the ID to parent
  }

  onChange(value: any, fieldName: keyof PropertyDescriptionVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }

  handleOnSegmentChange(segment: string, blockName: string) {
    if (this.block.variables) {
      this.block.variables[blockName as keyof PropertyDescriptionVariables] = segment;
      this.blockData.emit(this.block);
    }
    return;
  }
}
